import { useMemo } from 'react';

import { sanitizeListingDescription } from './sanitizeListingDescription';

type Props = {
  html: string | null | undefined;
  className?: string;
};

/**
 * A listing description rendered as HTML, but only within the cabinet editor's whitelist (api#211).
 * The api already stores nothing else; this is the storefront's second line, so the one place that
 * turns stored text into markup never trusts it blindly.
 */
export function SafeHtml({ html, className }: Props) {
  const clean = useMemo(() => sanitizeListingDescription(html), [html]);

  // The server sanitizes in jsdom and the browser in its own DOM, through one whitelist; should the
  // two ever serialize a tag differently, the browser keeps the server's markup and says nothing.
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} suppressHydrationWarning />;
}
